import styled from 'styled-components';
import { TextField } from '@mui/material';

import { COLORS } from 'helpers/enums/colors';

export const CustomInput = styled(TextField)`
  && {
    width: 100%;
    height: 100%;
    margin-bottom: 0px !important;

    label {
      color: ${({ error }) => (error ? COLORS.redMonza : COLORS.grayManatee)};
      font-family: 'Montserrat', Helvetica, Arial, serif;
      font-size: 16px;
      left: 10px;
      padding-right: 50px;
    }

    .MuiFormLabel-root.Mui-focused,
    .MuiFormLabel-filled {
      color: ${({ error }) => (error ? COLORS.redMonza : COLORS.grayLynch)};
      font-size: 12px;
      font-weight: 700;
    }

    .MuiInputBase-input {
      padding: 18px 20px 8px;
      color: ${COLORS.grayCloudBurst};
      font-family: 'Montserrat', Helvetica, Arial, serif;
      font-size: 18px;
      border-radius: 6px;

      &:-webkit-autofill,
      &:-webkit-autofill:active,
      &:-webkit-autofill:hover,
      &:-webkit-autofill::first-line,
      &:-webkit-autofill:focus {
        -webkit-box-shadow: 0 0 0px 1000px white inset !important;
        background-color: ${COLORS.white} !important;
        background-clip: content-box !important;
      }
    }

    .MuiFilledInput-root {
      background-color: ${COLORS.white};
      border: 2px solid ${({ error }) => (error ? COLORS.redMonza : COLORS.grayManatee)};
      border-radius: 6px;
      height: 100%;

      :before,
      :after {
        content: none;
      }
    }

    .MuiInputBase-input.Mui-disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;
